<template>
<div style="height:100%;">
        <!-- <div  style="width: 100%;background-color: rgb(34, 34, 34);height:54px;">
        <span data-v-3c6d3300="" style="margin-left: 20px; float: left;">
            <img data-v-3c6d3300="" src="../assets/img/MKD-logo.png" style="max-height: 50px;cursor:pointer;" @click="toOurWeb()">
            
        </span>
    </div>
       <div style="width:70%;margin:auto;font-size: 1.17em;padding-top:50px;">
         
            <p>Dear Customers,</p> 
            Due to a very high demand to access to our platform, 
            We are sorry to inform you that new requests to access to our service for customers with less than 30 orders per day are currently closed. 
            We are sorry for the inconvenience.
            We're currently creating a new system to allow sellers with less than 30 orders per day to use our service, 
            It should be ready in 2 or 3 months.
            <p>Thank you for your understanding</p>
            <P style="text-align:right;margin-right:170px;">SR Team</P> 
        </div> -->
        <!-- <div style="margin-top:150px;"> -->
    <div style="display:flex;    min-height: 100%;">
        <div style="width:65%;">
            <div :style="login_bk_bj">
                <div class="login-opactiy2"></div>
                <div class="systemTopText">
                    <div class="systemTopText-one">
                        Boost your business
                    </div>
                    <div class="systemTopText-two">
                        with <img src="../assets/img/shipping.png" alt="" style="width: 40%;margin-left: 2%;">
                    </div>
                    <div style="font-size: 26px;line-height: 2rem;margin-top:10%;font-weight:300;"> 
                        <div>
                            Easily find products to sell online
                        </div>
                        <div>
                            ship them directly to your customers.
                        </div>
                    </div>
                    <div style="font-size: 22px;line-height: 2rem;margin-top:30%; font-weight: lighter;font-style: oblique;display:flex;"> 
                        <div style="display:inline-block;">
                             <img src="../assets/img/douhao.png" alt="" width="17px">
                        </div>
                        <div style="display:inline-block;font-weight: lighter;">
                            
                            <!-- <span style="font-size:50px">“</span> -->
                            It has never been easier to start your own dropshipping
                            <div>
                                business with Shipping Revolution. Shipping Revolution
                            </div>
                            <div>
                                lets you  find products on the world's most popular market-
                            </div>
                            <div>
                                places,add them to your e-commerce store, and ship them
                            </div>
                            <div style="display:flex;align-items: end;">
                                directly to your customers. 
                                <img src="../assets/img/douhao2.png" alt="" width="17px">
                                <!-- <span style="font-size:50px;display:inline-block;margin-left:15%">”</span> -->
                            </div>
                        </div>
                       
                      
                    </div>
                   
                </div>
            </div>
        </div>
       
        <div class="Systemlogin-container">
            
            <div class="systemLogin">
                <div style="width:100%;padding: 0 13%;">

                
                    <div class="login-logo-img"> 
                    <img src="../assets/img/MKD-logo3.png" alt=""> 
                    </div>
                    <div>
                        <el-form class="login-form" autoComplete="on"   ref="loginForm" label-position="left">
                            <div class="title-container">
                                <h3 class="title" style="display:inline-block;color:#000;">{{gets('$系统登录')}}</h3>
                                <lang-select class="set-language right lan"></lang-select>
                            </div>
                            <el-form-item prop="username">
                                <span class="svg-container svg-container_login">
                                <svg-icon icon-class="user" />
                                </span>
                                <div>{{gets('$登录名称')}}</div>
                                <el-input  type="text" v-model="loginPage.LoginName.value" autocomplete="off" :placeholder="gets('$输入{登录名}')" />
                            </el-form-item>

                            <el-form-item prop="password">
                                <span class="svg-container">
                                <svg-icon icon-class="password" />
                                </span>
                                <div>{{gets('$密码')}}</div>
                                <el-input  type="password"  @keyup.enter.native="login()" autocomplete="off" v-model="loginPage.Password.value" :placeholder="gets('$输入{密码}')" />
                                <span class="show-pwd" >
                                <svg-icon icon-class="eye" />
                                </span>
                            </el-form-item>
                                <el-form-item style="display: flex;justify-content: flex-end;">
                                <el-checkbox v-model="checked" name="记住密码">{{gets('$记住密码')}}</el-checkbox>
                                </el-form-item> 

                            {{loginPage.LoginName.error}}
                            {{loginPage.Password.error}}
                            <el-button type="success" @click="login">{{gets('$登录')}}</el-button>


                        </el-form>
                    </div>
                </div>
            </div>
            
            

        </div>
    </div>
  <!-- </div> -->
</div>
</template>
<!--
<template>
<div>
    <el-select v-model="loginPage.Value" @change="LenChange()">
        <el-option v-for="item in ls" :value="item.Value" :label=" item.Text"></el-option>
    </el-select>
    <div class="container-fluid">
        <div style="margin: 100px auto; width: 500px;">
            <form role="form">
                <form-group :placeholder="gets('$输入{登录名}')" :j="{rex:'w',tips:'登录名为必填'}" v-model="loginPage.LoginName.value" :error="loginPage.LoginName.error" :labelName="gets('$登录名')"></form-group>
                <form-group :placeholder="gets('$输入{密码}')" :j="{rex:'w',tips:'密码为必填'}" :error="loginPage.Password.error" v-model="loginPage.Password.value" :labelName="gets('$密码')"></form-group>
                <el-button @click="login()" class="btn btn-default">{{gets('$登录')}}</el-button>
            </form>
        </div>
    </div>
</div>
</template>
-->
<script>


import {
    languageRequest
} from '../request/language'
import {
    userRequest
} from '../request/user.js'
import {
    ToComponentData,
    CheckByConfig,
    ToSubmitData
} from '../config/config.js'
import {
    LoginPage
} from '@/config/Sys/userConfig.js'

import gets from '@/model/language'

//Check() {
//         ObjectCheck(this.j,this.value)
//       },

export default {
    data() {
        return {
            checked:false,
            Value: 'EN',
            LoginName: '',
            Password: '',
            login_bk_bj: {
                backgroundImage: "url(" + require("@/assets/img/systemLoginBG2.jpg") + ")",
                backgroundRepeat: "no-repeat",
                backgroundSize: "cover",
                width: "100%",   
                height:"100%",
               
            },
        }
    },
    created() {
         
        if(window._$isCustmerLogin){
             this.$router.push('/Customerlogin')
        }else{
            this.loginPage.Value = window.$.cookie('LanguagesTag')
            if(!this.loginPage.Value)
            {
                    this.loginPage.Value = 'EN';
                    this.LenChange()
            }
        }
        
    },
    mounted() {
 
        this.account(); //获取cookie的方法
    },
    computed: {
        loginPage() {
            self = this;
            if (!self.$store.state.loginPage) {
                var d = ToComponentData(LoginPage)
                d.Value = 'CN'
                self.$set(self.$store.state, "loginPage", d)
            }
            return self.$store.state.loginPage
        },
        ls() {
            window.rootVue = this;
            self = this;
            if (!self.$store.state.Languages) {
                languageRequest.GetLanguages(function(d) {
                    self.$set(self.$store.state, "Languages", d)
                })
            }
            return self.$store.state.Languages
        },
    },
    methods: {
        account() {
            // if (document.cookie.length <= 0) {
            console.log(this.getCookie("username"));
            // loginPage.LoginName.value
            this.loginPage.LoginName.value = this.getCookie("username");
            console.log(this.loginPage.LoginName.value,"this.loginPage.LoginName.value")
            if(this.getCookie("username")&&this.getCookie("username")!=""){
                this.checked=true
                // this.loginPage.LoginName.value==""
                // this.loginPage.Password.value==""
            }
            this.loginPage.Password.value = this.getCookie("password");
            // }
        },

        // toOurWeb(){
        //     window.open("http://service.shipping-revolution.com/")
        // },
        gets(tag) {
            var d = gets(tag)
            return d;
        },
         getCookie(name) {
            var arr = document.cookie.split(";");
            //["_ga=GA1.1.1756734561.1561034020", " mobile=123" password=456"]
            for (var i = 0; i < arr.length; i++) {
                var arr2 = arr[i].split("="); // ["_ga", "GA1.1.1756734561.1561034020"]
                if (arr2[0].trim() == name) {
                return arr2[1];
                }
            }
         },
          clearCookie() {
            this.setCookie("", "", -1); //清除cookie
            },
        LenChange() {
            window.$.cookie('LanguagesTag', this.loginPage.Value)
            languageRequest.Change(function(d) {
                window.location.reload()
            }, this.loginPage.Value)

        },
        setCookie(c_name, c_pwd, exdate) {
            //账号，密码 ，过期的天数
            var exdate = new Date();
        
            exdate.setTime(exdate.getTime() + 24 * 60 * 60 * 1000 * exdate); //保存的天数
            document.cookie =
                "username=" + c_name + ";path=/;expires=" + exdate.toLocaleString();
            document.cookie =
                "password=" + c_pwd + ";path=/;expires=" + exdate.toLocaleString();
        },

        login() {
            this.$store.state.UserRights.Rights = [];
            window.ISGETRights = false;
            self = this;
            if (CheckByConfig(LoginPage, self.$store.state.loginPage)) {
                console.log(LoginPage,self.$store.state.loginPage,11111)
                if (self.checked == true) {
                    //存入cookie
                    self.setCookie(
                    self.$store.state.loginPage.LoginName.value,
                    encodeURI(self.$store.state.loginPage.Password.value),
                    7
                    ); //保存7天
                } else {
                    self.clearCookie();
                }

                userRequest.login(function(d) {
                    console.log(self.$store.state.loginPage)
                    if (d.Message == "OK") {
                        self.$router.push('/Main/Index')
                        if(d.OrderMSG!=""){
                            self.$message.error(d.OrderMSG);
                        }
                    } else {
                        self.$message.error(d.Message);
                    }
                }, ToSubmitData(this.$store.state.loginPage))
            }
        },
    }
}

var self;

</script>


<style>

html{
    background-color: #F5F9FD;
    color: #666;
}
.sidentify{
    display: flex;
    justify-content: flex-end;
}
.Systemlogin-container{
width:35%;
background-color: #fff;
    position: relative;

   font-family:Helvetica;
    color: black;
}
.Systemlogin-container .title{
    font-size: 21px;
    margin-top: 20px;
    font-weight: 600;
}
.Systemlogin-container .el-form-item{
    margin-bottom: 0px;
}
.Systemlogin-container .el-button--success{
    background-color: #00CC05;
    margin-bottom: 30px;
    border-radius: 15px;
    float: right;
    margin-top: 20px;
}
.systemTopText .systemTopText-one{
    /* font-size: 46px;
    color: #fff;
    font-weight: 700; */
}
.systemTopText .systemTopText-two{
    display: flex;
    align-items: center;
    
}
.systemTopText{
    font-size: 46px;
    font-family: Helvetica;
    color: #fff;
    font-weight: 700;
    padding: 5%;
    line-height: 4.5rem;
}
.Systemlogin-container .systemLogin{
    /* margin: 0 13%; */
    display: flex;
    align-items: center;
    min-height: 100%;
}
.login-opactiy2{
    width:100%;
    height: 100%;
    position: absolute;
    top:0;
    z-index: 0;
    background: #000;
    opacity: 0.3;
      border: 0 solid rgba(120, 130, 140, 0.13);
    border-radius: 5px;
    box-shadow: 0 5px 20px rgba(0, 0, 0, 0.05);
    
}
.Systemlogin-container .login-form{
    padding: 20px 50px;
}
.Systemlogin-container .login-form .title-container{
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;
}
.Systemlogin-container .el-input__inner{
    border-radius: 10px;
    background-color: #E6F0FE;
}
.Systemlogin-container .login-logo-img{
    
    width: 100%;
}
.Systemlogin-container .login-logo-img img{
    width: 55%;
}
.right{
    float: right;
}

.lan .el-dropdown-selfdefine  span
{
  color:#000 !important;
}
</style>



// WEBPACK FOOTER //
// login.vue?43f96b1d